<div [formGroup]="parentForm" class="date-time-picker">
  <mat-form-field>
    <input matInput [required]="isRequired" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" [placeholder]="placeholder"
      [formControlName]="formFieldName" [min]="min" [max]="max" (dateTimeChange)="changed($event)" (keypress)="restrictEvent($event)">
    <span [owlDateTimeTrigger]="dt1" class="add-date">
      <itb-square-button [iconClassName]="'add-date'" [className]="'btn-square-lg'">
      </itb-square-button>
    </span>
    <owl-date-time [pickerType]="pickerType" [showSecondsTimer]="true" [hour12Timer]="hourFormate" #dt1></owl-date-time>
  </mat-form-field>
</div>